import {
  SnippetElement,
  defineElement,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-main-blog/common-main-blog.ts
var CommonMainBlog = class extends SnippetElement {
  connectedCallback() {
    this.tags.forEach((tag) => {
      const tagText = tag.innerHTML.toLowerCase();
      const pattern = new RegExp(`[/+]${tagText}`, "i");
      if (pattern.test(window.location.pathname)) {
        tag.classList.add("tag-active");
      }
    });
  }
};
__decorateClass([
  queryAll(".tags a:not([no-tag])")
], CommonMainBlog.prototype, "tags", 2);
CommonMainBlog = __decorateClass([
  defineElement("common-main-blog")
], CommonMainBlog);
export {
  CommonMainBlog
};
